/** Formátování hodnot pro české prostředí. */

const dateTimeFormat = new Intl.DateTimeFormat('cs-CZ', {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const dateFormat = new Intl.DateTimeFormat('cs-CZ', {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
})

/** MariaDB vrací DATETIME jako `2026-08-11 14:23:00`, což Safari neparsuje. */
function toDate(value: string): Date {
  return new Date(value.includes('T') ? value : value.replace(' ', 'T'))
}

export function formatDateTime(value: string | null): string {
  if (!value) return '—'
  return dateTimeFormat.format(toDate(value))
}

export function formatDate(value: string | null): string {
  if (!value) return '—'
  return dateFormat.format(toDate(value))
}

/** Relativní čas typu „před 3 dny"; u starších dat se vrátí datum. */
export function formatRelative(value: string | null): string {
  if (!value) return 'nikdy'

  const diffMs = Date.now() - toDate(value).getTime()
  const minutes = Math.round(diffMs / 60000)

  if (minutes < 1) return 'právě teď'
  if (minutes < 60) return `před ${minutes} min`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `před ${hours} h`

  const days = Math.round(hours / 24)
  if (days === 1) return 'včera'
  if (days < 30) return `před ${days} dny`

  return formatDate(value)
}

export function formatDuration(ms: number): string {
  const totalSeconds = Math.round(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  if (minutes === 0) return `${seconds} s`
  return `${minutes} min ${seconds.toString().padStart(2, '0')} s`
}

export function formatNumber(value: number, precision = 2): string {
  return value.toLocaleString('cs-CZ', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
}

/**
 * Změna proti výchozí hodnotě v procentech, včetně znaménka.
 * `null` znamená, že se nemá k čemu vztáhnout.
 */
export function formatChange(from: number, to: number): string | null {
  if (!Number.isFinite(from) || from === 0) return null
  const change = ((to - from) / from) * 100
  if (!Number.isFinite(change)) return null
  const sign = change > 0 ? '+' : ''
  return `${sign}${change.toFixed(0)} %`
}

/** Skloňování podle českých pravidel: 1 série, 2–4 série, 5+ sérií. */
export function plural(count: number, one: string, few: string, many: string): string {
  if (count === 1) return one
  if (count >= 2 && count <= 4) return few
  return many
}
